import { initSentry } from "./lib/sentry";
initSentry();

import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { initWebVitalsReporting } from "./lib/web-vitals-reporting";
import "./index.css";

initWebVitalsReporting();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </ErrorBoundary>,
);
